<template>
    <ModalLayout
        ref="self"
        class="BonusKnowledge"
        :collapsed="collapsed"
        xkeep-header
        @request-collapse="$emit('request-collapse')"
    >
        <!-- <div
      slot="header"
      class="header-fixed resultSection"
    >
      <MyAvatar
        class="avatar"
      />
      <div class="resultSection__textBox">
        <div class="resultTitle">
          Din hukommelses-IQ
        </div>
        <div class="resultNumber">
          {{ memoryIQ }}
        </div>
      </div>
      <PlainButton
        class="shareButton"
      >
        <svgicon icon="facebook" />
        {{ $t('shareButton') }}
      </PlainButton>
      <div
        v-if="didImprove"
        class="resultSubtitle"
      >
        Du har forbedret hukommelsen din med {{ improvementPercentage }}%
      </div>
    </div> -->

        <div slot="collapsedContent" class="collapsedContent xclaimSection">
            <div class="resultSection">
                <MyAvatar class="avatar" />
                <div class="resultSection__textBox">
                    <div class="resultTitle">
                        Din hukommelses-IQ
                    </div>
                    <div class="resultNumber">
                        {{ memoryIQ }}
                    </div>
                </div>
                <!-- <PlainButton
          class="shareButton"
        >
          <svgicon icon="facebook" />
          {{ $t('shareButton') }}
        </PlainButton> -->
                <div v-if="didImprove" class="resultSubtitle">
                    Du har forbedret hukommelsen din med {{ improvementPercentage }}%
                </div>
            </div>

            <div class="claimSection">
                <div class="giftIcon" />
                <div class="claimSection__textBox">
                    <div class="claimSection__title">
                        {{ $t('bonusSectionTitle') }}
                    </div>
                    <div class="claimSection__subtitle">
                        {{ $t('bonusSectionSubtitle') }}
                    </div>
                </div>
                <PlainButton class="claimSection__button" @click="$emit('request-expand')">
                    {{ $t('collapsedButtonLabel') }}
                </PlainButton>
            </div>
        </div>

        <TextBlock slot="content">
            <p>Gratulerer med ditt første gjennomførte huskespill. Etter hvert vil dette gå helt av seg selv.</p>

            <p>Ordlisten du nå memorerte er faktisk rekkefølgen på de ti største landene i verden:</p>

            <div class="compactList">
                <ol>
                    <li><p>Putin = Russland</p></li>
                    <li><p>Kanadagås = Kanada</p></li>
                    <li><p>Det Hvite Hus = USA</p></li>
                    <li><p>Kinaputter = Kina</p></li>
                    <li><p>Sambadansere = Brasil</p></li>
                    <li><p>Kenguru = Australia</p></li>
                    <li><p>Turban = India</p></li>
                    <li><p>Maradona &amp; Messi = Argentina</p></li>
                    <li><p>Borat = Kasakhstan</p></li>
                    <li><p>Alger = Algerie</p></li>
                </ol>
            </div>

            <p>Morsomt, ikke sant?</p>

            <p>
                Nå har du hilst på de første tallfigurene i Memolife-systemet – hjernespråket som gjør det lettere å
                lagre, organisere og samarbeide med andre om alt det spennende av ferdigheter, kunnskap og vaner du vil
                mestre i livet.
            </p>

            <p>
                Snart kan du bruke resten av Memolife-systemet til å ligge et hode foran med de viktigste
                fremtidsferdighetene, og mestre i alt 100 ferdigheter like raskt.
            </p>
        </TextBlock>
        <div slot="content" class="footer">
            <PlainButton class="button" @click="goNext()">
                Fortsett
            </PlainButton>
        </div>
        <div slot="content">
            <div class="afterFooter">
                Fortsett videre til Memolife-dashboardet
            </div>
        </div>
    </ModalLayout>
</template>

<translations>
  bonusSectionTitle: 'Bonus'
  bonusSectionSubtitle: 'Se hva annet du har lært'
  # collapsedButtonLabel: 'Claim'
  collapsedButtonLabel: 'Se nå'
  shareButton: 'Share'
</translations>

<script>
import MyAvatar from '@/components/MyAvatar';
import ModalLayout from './ModalLayout';
import PlainButton from './PlainButton';
import TextBlock from './TextBlock';

export default {
    components: { ModalLayout, PlainButton, TextBlock, MyAvatar },
    props: {
        collapsed: {
            type: Boolean
        }
    },
    computed: {
        scoreA() {
            return (
                this.$store.state.moduleMemogenius.settings.memoryOnboardingTestA || { correctCount: 0, totalCount: 10 }
            );
        },
        scoreB() {
            return (
                this.$store.state.moduleMemogenius.settings.memoryOnboardingTestB || { correctCount: 0, totalCount: 10 }
            );
        },
        memoryIQ() {
            // NOTE: assuming totalCount is 10
            return this.scoreA.correctCount * 10 + this.scoreB.correctCount * 10;
        },
        didImprove() {
            return this.scoreA.correctCount && this.scoreB.correctCount > this.scoreA.correctCount;
        },
        improvementPercentage() {
            return Math.round((this.scoreB.correctCount / this.scoreA.correctCount) * 100 - 100);
        }
    },
    methods: {
        getCollapsedHeight() {
            return this.$refs.self.getCollapsedHeight();
        },
        goNext() {
            this.$router.push({
                name: 'DashboardHomeView'
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.BonusKnowledge {
}

.collapsedContent {
    // display: flex;
    // align-items: center;
    // padding: 1em;
}

.header-fixed {
    // padding: 1em;
    // position: relative;
}

.resultSection {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 1em;
    position: relative;
}
.resultSubtitle {
    width: 100%;
    padding-top: 0.5em;
    color: rgba(black, 0.5);
    border-top: 1px solid rgba(black, 0.05);
    margin-top: 0.5em;

    margin-bottom: -0.4em;
}

.avatar {
    $borderWidth: 0.4em;
    $size: 4em;
    width: $size;
    height: $size;
    margin-right: 1em;
    flex-shrink: 0;
    border: $borderWidth solid mix(black, white, 5%);
    margin-right: 1em;
}

.label {
    color: rgba(black, 0.5);
}
.number {
    font-size: 120%;
}
.resultSection__textBox {
    flex: 1;
}
.resultTitle {
    color: rgba(black, 0.5);
}
.resultNumber {
    font-weight: 600;
    font-size: 180%;
}
.shareButton {
    background-color: #425892 !important;
    // text-transform: uppercase;
    .svg-icon {
        $size: 1em;
        width: $size;
        height: $size;
        fill: white;
    }
}

.divider {
    height: 1px;
    background-color: mix(white, black, 95%);
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
}

.compactList {
    display: flex;
    justify-content: center;
    margin-left: -0.5em; // NOTE: Small adjustment to try to fit some text on one line
    margin-right: -0.5em;
}
.TextBlock {
    /deep/ .StyledArticle {
        // NOTE: resetting some style to avoid a bug where 10. breaks on two lines
        li {
            white-space: nowrap;
        }
        li::before {
            display: none;
            // width: 3em;
            // margin-left: -2.5em;
            // white-space: nowrap;
        }
        ol {
            list-style: decimal;
            font-size: 90%;
            // counter-reset: li;
            // padding-left: 1.5em;
        }
    }
}

.footer {
    display: flex;
    justify-content: center;
    padding: 1em;
}
.afterFooter {
    text-align: center;
    padding-bottom: 2em;
    color: rgba(black, 0.5);
}

.claimSection {
    display: flex;
    align-items: center;
    padding: 1em;
    border-top: 1px solid rgba(black, 0.05);
}
.claimSection__textBox {
    flex: 1;
}
.claimSection__title {
    font-weight: 600;
    font-size: 120%;
}
.claimSection__subtitle {
    margin-top: 0.3em;
    line-height: 1.4em;
}
.giftIcon {
    $size: 4em;
    width: $size;
    height: $size;
    background-image: url('./gift.png');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    margin-right: 1em;
}
.claimSection__button,
.shareButton {
    font-size: 90%;
    padding: 1em;
    margin-left: 1em;
}
</style>
